'use client';

import {Box, Select, styled, Tabs, Tab, Typography} from '@mui/material';
import {StyledSectionContainer} from '@/components/sections/shared/Section.styles';

export const StyledToggleContentHeading = styled(Typography)(({theme}) => ({
  color: theme.palette.text.dark,
  marginBottom: theme.spacing(3),
}));

export const StyledToggleContentSectionContainer = styled(StyledSectionContainer)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.palette.text.dark,
}));

export const StyledToggleContentTabs = styled(Tabs)(({theme}) => ({
  width: '100%',
  backgroundColor: theme.palette.background.grey,
  borderRadius: theme.shape.borderRadiusFull,
  padding: theme.spacing(0.5, 0.5),

  '& .MuiTabs-scroller': {
    width: '100%',
  },

  '& .MuiTabs-flexContainer': {
    gap: theme.spacing(1),
  },

  '& .MuiTabs-indicator': {
    display: 'none',
  },
}));

export const StyledToggleContentTab = styled(Tab)(({theme}) => ({
  textTransform: 'none',
  minHeight: 40,
  borderRadius: theme.shape.borderRadiusFull,
  padding: theme.spacing(0, 2),
  color: theme.palette.text.dark,
  fontSize: theme.typography.tabs.fontSize,
  flex: 1,
  maxWidth: 'none',
  minWidth: 0,

  '& .MuiTouchRipple-root': {
    display: 'none',
  },

  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.15)',
  },

  '&.Mui-selected': {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.background.activeTab,
  },

  '&.Mui-focusVisible': {
    outline: `2px solid ${theme.palette.text.dark}`,
    outlineOffset: 2,
  },

  '&.Mui-selected.Mui-focusVisible': {
    outline: `2px solid ${theme.palette.common.white}`,
    outlineOffset: 2,
  },
}));

export const StyledToggleContentSelect = styled(Select)(({theme}) => ({
  width: '100%',
  backgroundColor: theme.palette.background.grey,
  borderRadius: theme.shape.borderRadiusLg,
  color: theme.palette.text.dark,
  fontSize: theme.typography.tabs.fontSize,

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },

  '& .MuiSvgIcon-root': {
    color: theme.palette.text.dark,
  },
}));

export const StyledToggleContentItemContainer = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  gap: theme.spacing(4),
  marginBottom: theme.spacing(4),
  alignItems: 'stretch',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const StyledToggleContentMediaContainer = styled(Box)(({theme}) => ({
  borderRadius: theme.shape.borderRadiusLg,
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  height: 325,
  [theme.breakpoints.down('md')]: {
    height: 300,
  },
  [theme.breakpoints.down('sm')]: {
    height: 275,
  },
}));